import { createGlobalStyle } from "styled-components";
import { globalStyles } from "twin.macro";

const GlobalStyles = createGlobalStyle(
  globalStyles,
  `
   :root {
     --app-content-gutter: 1.5rem;
   }

   @media (min-width: 768px) {
     :root {
       --app-content-gutter: 4rem;
     }
   }

   html, body, #root {
     margin: 0;
     padding: 0;
     width: 100%;
     min-height: 100%;
   }

   *, *::before, *::after {
     box-sizing: border-box;
   }

   .plans-modal-overlay {
     position: fixed;
     inset: 0;
     background: rgba(20, 20, 20, 0.45);
     z-index: 60;
   }

   /* Below animations are for modal created using React-Modal */
     .ReactModal__Overlay {
     transition: transform 300ms ease-in-out;
     transition-delay: 100ms;
     transform: scale(0);
   }
   .ReactModal__Overlay--after-open{
     transform: scale(1);
   }
   .ReactModal__Overlay--before-close{
     transform: scale(0);
   }
`
);

export default GlobalStyles;
